import React from 'react';
import Routes from './containers/Routes';

const App = () => (
  <div className="App">
    <Routes />
  </div>
);

export default App;
